module.exports = __webpack_public_path__ + "static/media/bg_on_boarding2.061de301.png";